module.exports = "query ExportFormQUery{exportUploadRoute:route(name:\"export_upload\"){url}}"